<template>
  <div class="palestra mb-4">
    <div class="img-holder d-flex flex-column justify-content-center pl-4 pr-4">
      <b-img class="img-palestrante" fluid :src="palestrante.photo" />
    </div>
    <div class="conteudo">
      <div class="informacoes">
        <div class="titulo">{{ palestrante.name }}</div>
      </div>
      <div class="informacoes">
        <div class="sub-titulo pt-2">{{ palestrante.institution }}</div>
      </div>
    </div>

    <div class="painel">
      <ButtonFill
        texto="Editar informações"
        @click="onClickEditar(palestrante._id)"
      ></ButtonFill>
      <ButtonOutline texto="Excluir" @click="onClickExcluir(palestrante)" />
    </div>
  </div>
</template>

<script>
import ButtonFill from "@/components/Button-fill.vue";
import ButtonOutline from "@/components/Button-outline.vue";

export default {
  components: {
    ButtonFill,
    ButtonOutline,
  },
  computed: {
    imagem() {
      return {
        background: `url(${this.$props.palestrante.photo}) no-repeat center center`,
      };
    },
  },
  props: {
    palestrante: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onClickEditar(idPalestrante) {
      this.$router.push(`/admin/editar-palestrante/${idPalestrante}`);
    },
    onClickExcluir(palestrante) {
      this.$emit("excluir", palestrante);
    },
  },
};
</script>

<style lang="scss" scoped>
.img-holder {
  height: 100%;

  .img-palestrante {
    height: 100px;
    width: 100px;
    border-radius: 5px;
    object-fit: cover;
  }
}
</style>

<style lang="scss" scoped>
.palestra {
  width: 80%;
  height: 8.5rem;
  border-style: solid;
  border-width: 1px;
  border-image: linear-gradient(
      247.22deg,
      #2b195d 0%,
      #7528c2 52.47%,
      #d640f4 98.97%,
      #7528c2 114.48%
    )
    1;
  display: flex;
  flex-direction: row;
  .foto {
    height: 8.5rem;
    width: 8.5rem;
    padding: 20px;
    .imagem {
      height: 100%;
      width: 100%;
      border-radius: 50%;
    }
  }
  .conteudo {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 4;
    padding-top: 20px;
    padding-bottom: 20px;
    .informacoes {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .titulo {
        font-size: 1.5rem;
        font-weight: 600;
      }
      .sub-titulo {
        font-size: 1.25rem;
        font-weight: 400;
      }
      .estado {
        color: #ff1601;
        font-size: 1.75rem;
      }
    }
    .nome {
      font-size: 1.5rem;
      font-weight: 200;
    }
    .resumo {
      font-size: 1rem;
      font-weight: 400;
      text-align: justify;
    }
  }
  .horario {
    font-size: 1.3rem;
    padding: 20px;
    margin-right: -402px;
  }
  .painel {
    height: 100%;
    display: flex;
    flex: 1;
    padding: 20px;
    margin-top: 40px;
    align-items: center;
    flex-direction: row;
  }
  .btn-outline {
    width: 120px !important;
    border: 1px solid #707070 !important;
  }
}
</style>
